import Swiper from "swiper";

var swiper = new Swiper('.js-kv', {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  effect: 'fade',
});